export default "__VITE_ASSET__02b59fa3__"